import React from "react"
import { Modal } from "antd"
import "../../../styles/Pages/store.css"
import { translations } from "../../../utils/Translation/staticTranslation"

const DeleteConfirmationModal = ({
  deleteLoading,
  visible,
  onCancel,
  onConfirm,
  title,
  content,
  confirmDisabled = false,
}) => {
  const lang = localStorage.getItem("language") || "ar"
  const btn = translations[lang]?.common_btn
  const modal = translations[lang]?.modals

  return (
    <Modal
      title={title || "Confirm Delete"}
      open={visible}
      onCancel={onCancel}
      footer={[
        <button key="cancel" className="cancel-btn" onClick={onCancel}>
          {btn?.cancel_btn || "Cancel"}
        </button>,
        <button
          disabled={deleteLoading || confirmDisabled}
          key="delete"
          className={`${lang === "ar" ? "mr-10" : "ml-10"} delete-confirm-btn ${
            (deleteLoading || confirmDisabled) && "not-allowed"
          }`}
          onClick={onConfirm}
        >
          {deleteLoading ? btn?.deleting : btn?.delete}
        </button>,
      ]}
      centered={true}
    >
      <p>
        {content || (
          <>
            {modal?.description_1 ||
              "Are you sure you want to delete this item?"}{" "}
            {modal?.description_2 || "This action cannot be undone."}
          </>
        )}
      </p>
    </Modal>
  )
}

export default DeleteConfirmationModal
